import React, { useState } from "react";
import styled from '@emotion/styled';
import ImgTraining from "../assets/images/CNC-Training.jpg";
import ImageTitle from "../components/ImageTitle";
import Button from '@mui/material/Button';
import { FaArrowDown } from "react-icons/fa";

const Explore = () => {
    // Estado para controlar la visibilidad del simulador
    const [showSimulator, setShowSimulator] = useState(false);

    // Función para manejar el clic en el botón
    const handleButtonClick = () => {
        setShowSimulator(true); // Muestra el simulador al hacer clic
    };

    const TrainingDiv = styled.div`
        background:rgb(255, 255, 255);
        padding-bottom: 25px;
    `;

    const Descripcion = styled.p`
        font-family: "DM Sans", serif;
        font-size: 15px;
        color: black;
        padding: 20px;
        margin: 0px 50px;
        text-align: center;
        width: 70%;
        margin: auto;
    `;
  
    const ButtonText = styled.p`
        font-family: "DM Sans", serif;
        color: white;
        font-size: 20px;
        font-weight: 700;
    `;

    return (
        <TrainingDiv>
            <ImageTitle title="APRENDE+" subtitle="SALVANDO VIDAS, CAMBIANDO MENTALIDADES"  image={ImgTraining}/>
            <Descripcion>
                En la <strong>Coordinación Nacional de Capacitación</strong> creemos que la innovación es clave para transformar la forma en la que aprendemos a salvar vidas.
                <br /> <br />Nuestra prioridad siempre será tú: Asociado. Tu preparación, confianza y seguridad al actuar en situaciones reales.
                <br /> <br />Por eso desarrollamos herramientas didácticas que permiten practicar, explorar y aprender sin riesgo, pero con todo el compromiso. A través de simuladores, cuestionarios interactivos y entornos de aprendizaje dinámicos, buscamos fortalecer habilidades clave, promoviendo una cultura de mejora continua y excelencia operativa.
                <br /> <br /><br /> <br /><strong>Porque cada segundo cuenta, y cada vida importa.</strong>
            </Descripcion>
            <Button variant="contained" onClick={handleButtonClick}>
                <FaArrowDown color="white" size={30} />
            </Button>
        </TrainingDiv>
    );
};

export default Explore;
